import { render, staticRenderFns } from "./bulk-message-add-recipients-yet-to-customize-club-dialog.vue?vue&type=template&id=85174d32&scoped=true&"
import script from "./bulk-message-add-recipients-yet-to-customize-club-dialog.vue?vue&type=script&lang=js&"
export * from "./bulk-message-add-recipients-yet-to-customize-club-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85174d32",
  null
  
)

export default component.exports